exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-link {\n    color: #0f37da;\n}\n", ""]);

// exports
